export const OurStoryText = () => {
    return (
        <>
            <div className="full" id="full">
                <OurStoryTextFull />
            </div>
            <div className="halfQ" id="halfQ">
                <OurStoryText2 />
            </div>
            <div className="half" id="half">
                <OurStoryText3 />
            </div>
            <div className="small" id="small">
                <OurStoryText4 />
            </div>
        </>

    );
}

const OurStoryTextFull = () => {
    return (
        <>
            <p>At Page Partners, our journey began with a passion, a passion for Recruiting Strategically sourced and curated talent for connecting exceptional talent with our stakeholders in placing Top Talent.</p>
            <p>Over the years, we’ve come to realize that the world of recruitment is more than filling roles, it is about facilitating growth, igniting potential, and empowering individuals and organizations to succeed.</p>
            <p>This understanding inspired the naming of the company. A turning of the page to a new chapter in how recruitment is facilitated in today’s dynamic age.</p>
            <p>Page Partners is built on the belief that recruitment is not just a process but a partnership. We are here to bridge the gap between modern challenges and innovative solutions, ensuring that every step we take reflects purpose, precision, and progress.</p>
            <p>Our services are designed to meet the unique needs of both employers and candidates, offering tailored strategies that align with today’s fast changing workforce demands. From talent acquisition consulting to graduate recruitment and onboarding, we are committed to delivering excellence and fostering long-term relationships.</p>
            <p>Our business isn’t just about filling roles it’s about turning opportunities into milestones. Let us help you write the next chapter in your success story.</p>
        </>
    );
}


const OurStoryText2 = () => {

    const handleReadMoreLess = (type) => {

        const moreBtn = document.getElementById("halfQ-btn-more");
        const lessBtn = document.getElementById("halfQ-btn-less");
        const text = document.getElementById("halfQ-text");

        switch (type) {
            case "more":
                moreBtn.style.display = "none";
                lessBtn.style.display = "block";
                text.style.display = "block";
                break;

            default:
                moreBtn.style.display = "block";
                lessBtn.style.display = "none";
                text.style.display = "none";
                break;
        }
    }

    return (
        <>
            <p>At Page Partners, our journey began with a passion, a passion for Recruiting Strategically sourced and curated talent for connecting exceptional talent with our stakeholders in placing Top Talent.</p>
            <p>Over the years, we’ve come to realize that the world of recruitment is more than filling roles, it is about facilitating growth, igniting potential, and empowering individuals and organizations to succeed.</p>
            <p>This understanding inspired the naming of the company. A turning of the page to a new chapter in how recruitment is facilitated in today’s dynamic age.</p>
            <p>Page Partners is built on the belief that recruitment is not just a process but a partnership. We are here to bridge the gap between modern challenges and innovative solutions, ensuring that every step we take reflects purpose, precision, and progress.</p>
            <div id="halfQ-text">
                <p>Our services are designed to meet the unique needs of both employers and candidates, offering tailored strategies that align with today’s fast changing workforce demands. From talent acquisition consulting to graduate recruitment and onboarding, we are committed to delivering excellence and fostering long-term relationships.</p>
                <p>Our business isn’t just about filling roles it’s about turning opportunities into milestones. Let us help you write the next chapter in your success story.</p>
            </div>

            <button id="halfQ-btn-more" onClick={() => handleReadMoreLess("more")}>Read More...</button>
            <button id="halfQ-btn-less" onClick={() => handleReadMoreLess("less")}>Read Less...</button>
        </>
    );
}


const OurStoryText3 = () => {

    const handleReadMoreLess = (type) => {

        const moreBtn = document.getElementById("half-btn-more");
        const lessBtn = document.getElementById("half-btn-less");
        const text = document.getElementById("half-text");

        switch (type) {
            case "more":
                moreBtn.style.display = "none";
                lessBtn.style.display = "block";
                text.style.display = "block";
                break;

            default:
                moreBtn.style.display = "block";
                lessBtn.style.display = "none";
                text.style.display = "none";
                break;
        }
    }

    return (
        <>
            <p>At Page Partners, our journey began with a passion, a passion for Recruiting Strategically sourced and curated talent for connecting exceptional talent with our stakeholders in placing Top Talent.</p>
            <p>Over the years, we’ve come to realize that the world of recruitment is more than filling roles, it is about facilitating growth, igniting potential, and empowering individuals and organizations to succeed.</p>
            <p>This understanding inspired the naming of the company. A turning of the page to a new chapter in how recruitment is facilitated in today’s dynamic age.</p>
            <p>Page Partners is built on the belief that recruitment is not just a process but a partnership. We are here to bridge the gap between modern challenges and innovative solutions, ensuring that every step we take reflects purpose, precision, and progress.</p>
            <div id="half-text">
                <p>Our services are designed to meet the unique needs of both employers and candidates, offering tailored strategies that align with today’s fast changing workforce demands. From talent acquisition consulting to graduate recruitment and onboarding, we are committed to delivering excellence and fostering long-term relationships.</p>
                <p>Our business isn’t just about filling roles it’s about turning opportunities into milestones. Let us help you write the next chapter in your success story.</p>
            </div>

            <button id="half-btn-more" onClick={() => handleReadMoreLess("more")}>Read More...</button>
            <button id="half-btn-less" onClick={() => handleReadMoreLess("less")}>Read Less...</button>
        </>
    );
}


const OurStoryText4 = () => {

    const handleReadMoreLess = (type) => {

        const moreBtn = document.getElementById("small-btn-more");
        const lessBtn = document.getElementById("small-btn-less");
        const text = document.getElementById("small-text");

        switch (type) {
            case "more":
                moreBtn.style.display = "none";
                lessBtn.style.display = "block";
                text.style.display = "block";
                break;

            default:
                moreBtn.style.display = "block";
                lessBtn.style.display = "none";
                text.style.display = "none";
                break;
        }
    }

    return (
        <>

            <p>At Page Partners, our journey began with a passion, a passion for Recruiting Strategically sourced and curated talent for connecting exceptional talent with our stakeholders in placing Top Talent.</p>
            <p>Over the years, we’ve come to realize that the world of recruitment is more than filling roles, it is about facilitating growth, igniting potential, and empowering individuals and organizations to succeed.</p>
            <p>This understanding inspired the naming of the company. A turning of the page to a new chapter in how recruitment is facilitated in today’s dynamic age.</p>
            <div id="small-text">
                <p>Page Partners is built on the belief that recruitment is not just a process but a partnership. We are here to bridge the gap between modern challenges and innovative solutions, ensuring that every step we take reflects purpose, precision, and progress.</p>
                <p>Our services are designed to meet the unique needs of both employers and candidates, offering tailored strategies that align with today’s fast changing workforce demands. From talent acquisition consulting to graduate recruitment and onboarding, we are committed to delivering excellence and fostering long-term relationships.</p>
                <p>Our business isn’t just about filling roles it’s about turning opportunities into milestones. Let us help you write the next chapter in your success story.</p>
            </div>

            <button id="small-btn-more" onClick={() => handleReadMoreLess("more")}>Read More...</button>
            <button id="small-btn-less" onClick={() => handleReadMoreLess("less")}>Read Less...</button>
        </>
    );
}




export const FounderText = () => {
    return (
        <>
            <div id="founder-full">
                <FounderTextFull />
            </div>
            <div id="founder-full-half">
                <FounderTextFullHalf />
            </div>
            <div id="founder-half">
                <FounderTextHalf />
            </div>
            <div id="founder-quarter">
                <FounderTextQuarter />
            </div>
        </>
    );
}


const FounderTextFull = () => {
    return (
        <>
            <p>My journey is rooted in a simple yet profound passion, <b>people.</b> With a background in Industrial Psychology, I’ve always believed that people are at the heart of every success story. This belief has shaped my career and inspired me to help individuals and organisations move towards greater fulfilment, growth, and success.</p>
            <p>For over 20 years, I’ve had the privilege of being part of countless career journeys and transformations. To me, recruitment has never been simply about filling roles, it has always been about creating opportunities, unlocking potential, and empowering both candidates and clients to achieve their aspirations.</p>
            <p>As the world of work continues to evolve, so too must the way we approach recruitment. I’ve embraced a fresh perspective on Recruitment Services, one that combines experience with innovative thinking and responds to the dynamic needs of today’s industries.</p>
            <p>This philosophy inspired the name <b>Page Partners,</b> a symbolic turning of the page and the beginning of a new chapter in how recruitment is envisioned and delivered.</p>
            <p>At the heart of Page Partners is a commitment to redefining how we connect talent with opportunity, guided always by three principles: <b>integrity, growth, and service.</b></p>
        </>
    );
}

const FounderTextFullHalf = () => {

    const handleReadMoreLess = (type) => {

        const moreBtn = document.getElementById("fh-more-btn");
        const lessBtn = document.getElementById("fh-less-btn");
        const text = document.getElementById("fh-text");

        switch (type) {
            case "more":
                moreBtn.style.display = "none";
                lessBtn.style.display = "block";
                text.style.display = "block";
                break;

            default:
                moreBtn.style.display = "block";
                lessBtn.style.display = "none";
                text.style.display = "none";
                break;
        }
    }

    return (
        <>
            <p>My journey is rooted in a simple yet profound passion, <b>people.</b> With a background in Industrial Psychology, I’ve always believed that people are at the heart of every success story. This belief has shaped my career and inspired me to help individuals and organisations move towards greater fulfilment, growth, and success.</p>
            <p>For over 20 years, I’ve had the privilege of being part of countless career journeys and transformations. To me, recruitment has never been simply about filling roles, it has always been about creating opportunities, unlocking potential, and empowering both candidates and clients to achieve their aspirations.</p>
            <p>As the world of work continues to evolve, so too must the way we approach recruitment. I’ve embraced a fresh perspective on Recruitment Services, one that combines experience with innovative thinking and responds to the dynamic needs of today’s industries.</p>
            <p>This philosophy inspired the name <b>Page Partners,</b> a symbolic turning of the page and the beginning of a new chapter in how recruitment is envisioned and delivered.</p>
            <p>This philosophy inspired the name Page Partners a symbolic turning of the page to a new chapter in how recruitment is envisioned and delivered. <span id="fh-text">At the core of this business is a commitment to redefining the way we connect talent with opportunity, always guided by the values of integrity, growth, and service.</span></p>

            <button id="fh-more-btn" onClick={() => handleReadMoreLess("more")}>Read More...</button>
            <button id="fh-less-btn" onClick={() => handleReadMoreLess("less")}>Read Less...</button>
        </>
    );
}
const FounderTextHalf = () => {
    const handleReadMoreLess = (type) => {

        const moreBtn = document.getElementById("h-more-btn");
        const lessBtn = document.getElementById("h-less-btn");
        const text = document.getElementById("h-text");

        switch (type) {
            case "more":
                moreBtn.style.display = "none";
                lessBtn.style.display = "block";
                text.style.display = "block";
                break;

            default:
                moreBtn.style.display = "block";
                lessBtn.style.display = "none";
                text.style.display = "none";
                break;
        }
    }

    return (
        <>
            <p>My journey is rooted in a simple yet profound passion, <b>people.</b> With a background in Industrial Psychology, I’ve always believed that people are at the heart of every success story. This belief has shaped my career and inspired me to help individuals and organisations move towards greater fulfilment, growth, and success.</p>
            <p>For over 20 years, I’ve had the privilege of being part of countless career journeys and transformations. To me, recruitment has never been simply about filling roles, it has always been about creating opportunities, unlocking potential, and empowering both candidates and clients to achieve their aspirations.</p>
            <p>As the world of work continues to evolve, so too must the way we approach recruitment. I’ve embraced a fresh perspective on Recruitment Services, one that combines experience with innovative thinking and responds to the dynamic needs of today’s industries.</p>
            <p>This philosophy inspired the name <b>Page Partners,</b> a symbolic turning of the page and the beginning of a new chapter in how recruitment is envisioned and delivered.</p>
            <p id="h-text">At the heart of Page Partners is a commitment to redefining how we connect talent with opportunity, guided always by three principles: <b>integrity, growth, and service.</b></p>

            <button id="h-more-btn" onClick={() => handleReadMoreLess("more")}>Read More...</button>
            <button id="h-less-btn" onClick={() => handleReadMoreLess("less")}>Read Less...</button>
        </>
    );
}

const FounderTextQuarter = () => {
    const handleReadMoreLess = (type) => {

        const moreBtn = document.getElementById("q-more-btn");
        const lessBtn = document.getElementById("q-less-btn");
        const text = document.getElementById("q-text");

        switch (type) {
            case "more":
                moreBtn.style.display = "none";
                lessBtn.style.display = "block";
                text.style.display = "block";
                break;

            default:
                moreBtn.style.display = "block";
                lessBtn.style.display = "none";
                text.style.display = "none";
                break;
        }
    }
    return (
        <>
            <p>My journey is rooted in a simple yet profound passion, <b>people.</b> With a background in Industrial Psychology, I’ve always believed that people are at the heart of every success story. This belief has shaped my career and inspired me to help individuals and organisations move towards greater fulfilment, growth, and success.</p>
            <p>For over 20 years, I’ve had the privilege of being part of countless career journeys and transformations. To me, recruitment has never been simply about filling roles, it has always been about creating opportunities, unlocking potential, and empowering both candidates and clients to achieve their aspirations.</p>
            <p>As the world of work continues to evolve, so too must the way we approach recruitment. I’ve embraced a fresh perspective on Recruitment Services, one that combines experience with innovative thinking and responds to the dynamic needs of today’s industries.</p>
            <div id="q-text">
                <p>This philosophy inspired the name <b>Page Partners,</b> a symbolic turning of the page and the beginning of a new chapter in how recruitment is envisioned and delivered.</p>
                <p>At the heart of Page Partners is a commitment to redefining how we connect talent with opportunity, guided always by three principles: <b>integrity, growth, and service.</b></p>
            </div>

            <button id="q-more-btn" onClick={() => handleReadMoreLess("more")}>Read More...</button>
            <button id="q-less-btn" onClick={() => handleReadMoreLess("less")}>Read Less...</button>
        </>
    );
}